	export enum HistoryRecordStateEnum {
		Added = 1,
		Deleted = 2
	}
